<template>
  <div id="app">
    <Home/>
  </div>
</template>

<script>
import Home from '@/views/Home.vue'

export default {
	name: 'App',
	components: {
		Home,
  },
}
</script>

<style lang="scss">
@import "./styles/_variables.scss";
@import "./styles/redesign.scss";
@import "./styles/premium-system";
@import "./styles/motion";
</style>


